import { useQueryClient } from 'react-query';

export function useCypressHelper() {
  const queryClient = useQueryClient();
  if (window.Cypress) {
    window.__rqClient__ = queryClient;
  }
}
